module.exports = __webpack_public_path__ + "static/media/55.9b526c32.jpg";